export const environment = {
  production: true,
  endpoint: 'https://api-beta-abs.advocatively.com'
};
